export default __webpack_public_path__ + "static/media/cursorr_app_mokup.278279b5.png";